import {  useSelector } from "react-redux";
import FormProveedor from "../../../../components/formas/FormProveedor";


export const Editar = () => {
    const { proveedor } = useSelector((state) => state.proveedoresReducer);

    return <FormProveedor datos={proveedor}  />;
}
